import { trackEvent } from '../util/analytics'

up.compiler('[data-track-modal-closed]', (element: HTMLElement) => {
  const modal = element.closest('up-modal')
  if (modal) {
    return up.on('up:layer:dismiss', () => {
      trackEvent(element.getAttribute('data-track-modal-closed')!)
    })
  }
})
